import { Trans } from '@lyearn/i18n';

import fieldValidate from '../../helper/fieldValidate';
import {
  Field,
  FieldType,
  FieldValidationFunction,
  FieldValidationTypes,
  FormTextField,
} from '../../types';
import { FieldInputType } from '../types';
import Input from './Input';

const fieldValidation: FieldValidationFunction<string> = {
  [FieldValidationTypes.Required]: ({ value, validation }) => {
    if (value == undefined || value.trim() === '') {
      return validation?.message || <Trans i18nKey="Form:FieldRequiredMessage" />;
    }
  },
  [FieldValidationTypes.Custom]: () => undefined,
};

const TextInputField: FieldInputType<FormTextField, string> = {
  Input,
  type: FieldType.Text,
  validate: (field, value, values) => {
    return fieldValidate({ field, value, values, fieldValidation });
  },
};

export default TextInputField;
